import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const ShapeSideMenuIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.245 12.1099C9.72941 12.1099 7.69009 10.0706 7.69009 7.55494C7.69009 5.03932 9.72941 3 12.245 3C14.7607 3 16.8 5.03932 16.8 7.55494C16.8 10.0706 14.7607 12.1099 12.245 12.1099ZM6.69009 7.55494C6.69009 10.6228 9.17713 13.1099 12.245 13.1099C15.313 13.1099 17.8 10.6228 17.8 7.55494C17.8 4.48703 15.313 2 12.245 2C9.17713 2 6.69009 4.48703 6.69009 7.55494Z"
                fill={color}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1035 8.89648L3 8.89648V17L11.1035 17L11.1035 8.89648ZM3 7.89648C2.44772 7.89648 2 8.3442 2 8.89648V17C2 17.5523 2.44772 18 3 18H11.1035C11.6558 18 12.1035 17.5523 12.1035 17V8.89648C12.1035 8.3442 11.6558 7.89648 11.1035 7.89648H3Z"
                fill={color}
              />
            </svg>
          </>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

ShapeSideMenuIcon.displayName = "ShapeMenu";

export { ShapeSideMenuIcon };
